export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-3 sm:mb-8 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-heading text-2xl font-bold tracking-tight text-[#18221F] sm:text-3xl" data-testid="page-title">
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-sm text-[#4A5568]">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);
